import { TireList } from "@/@types/Tire";
import { ApiClient } from "../../ApiClient";
import { GetTireListResponse } from "../schema/GetTireListResponse";
import { mapTireList } from "../../mappers/tireListMapper";

export const getTireList = async (p0?: { page: string; }): Promise<TireList> => {
    const client = ApiClient.getInstance()
    const pageParam = p0?.page || '1';
    const response = await client.get<GetTireListResponse>(`tires?page=${pageParam}`)

    const mappedResponse = mapTireList(response)

    return mappedResponse;
}